import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { AgGridReact } from 'ag-grid-react'
import { setPreviewTable } from 'store/CustomReports/actions'
import { SlideHeader } from './SlideHeader'
import Data from './data'
import { setPreviewColumns } from 'store/CustomReports/actions'
import { setPreviewRows } from 'store/CustomReports/actions'
import { setContinueButtonText } from 'store/CustomReports/actions'
import { wait } from 'utils/helpers'
import { setContinueDisabled } from 'store/CustomReports/actions'
import { setFinalSlide } from 'store/CustomReports/actions'

export const FinalSlide = ({ viewOnly }) => {
  const dispatch = useDispatch()
  const {
    previewColumns,
    previewRows,
    possibleColumns,
    editingReport,
    exactReportType,
  } = useSelector((store) => store.customReports)

  useEffect(() => {
    dispatch(setPreviewTable(exactReportType))
  }, [dispatch, exactReportType])

  useEffect(() => {
    wait(() => {
      dispatch(setContinueDisabled(false))
      dispatch(
        setContinueButtonText(
          // !editingReport ? 'Download Report' : 'Save / Download Report'
          'Generate'
        )
      )
    })
  }, [dispatch, editingReport])

  useEffect(() => {
    dispatch(setFinalSlide(true))

    return () => {
      dispatch(setFinalSlide(false))
    }
  }, [dispatch])

  return (
    <>
      <Data />
      <SlideHeader header={'Preview Report'} />
      {possibleColumns?.map(
        ({
          headerName: c,
          field,
          id,
          val,
          onSelectFn,
          onDeselectFn,
          disabled,
        }) => {
          const selected = previewColumns.map((dc) => dc.headerName).includes(c)

          return (
            <>
              {!viewOnly ? (
                <div
                  key={c}
                  className='custom-control custom-checkbox mb-3'
                  style={{ zIndex: '0' }}
                >
                  <input
                    value={c}
                    className='custom-control-input'
                    id={c}
                    checked={selected}
                    disabled={disabled}
                    onChange={(e) => {
                      if (!selected) {
                        dispatch(
                          setPreviewColumns([
                            ...previewColumns,
                            { headerName: c, field, id },
                          ])
                        )
                        if (onSelectFn) {
                          dispatch(onSelectFn())
                          return
                        }
                        dispatch(
                          setPreviewRows(
                            previewRows.map((row) => ({
                              ...row,
                              [field]: val,
                            }))
                          )
                        )
                      } else {
                        if (onDeselectFn) {
                          dispatch(onDeselectFn())
                        }

                        dispatch(
                          setPreviewColumns(
                            previewColumns.filter((pc) => pc.headerName !== c)
                          )
                        )
                      }
                    }}
                    type='checkbox'
                  />
                  <label className='custom-control-label' htmlFor={c}>
                    {c}
                  </label>
                </div>
              ) : null}
            </>
          )
        }
      )}

      <div
        className='ag-theme-alpine mb-5'
        style={{ height: 400, width: '100%' }}
      >
        <AgGridReact
          columnDefs={previewColumns?.filter((pc) => pc.field)}
          rowData={previewRows}
          suppressMovableColumns={true}
        />
      </div>
    </>
  )
}
